import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { FilterDropdown } from 'components/shared/FilterDropdown/FilterDropdown'
import { DepartmentFilter } from 'components/shared/DepartmentFilter/DepartmentFilter'
import { PlusCircleIcon } from 'components/shared/Icon/Icon'

import { getFiltersConfigs } from './common/JobsTable/model'

import styles from './JobsListing.module.scss'

export const JobsHeader = ({
  search,
  onSearchChange,
  filter,
  onFilterChange,
  departmentValue,
  onDepartmentChange,
  actions,
  hasAnyTemplates,
  onAddJobFromTemplate,
  onAddJobFromScratch,
}) => (
  <Pane.Header title={t`Jobs`} contentClassName={styles.headerContent}>
    <DepartmentFilter value={departmentValue} onChange={onDepartmentChange} />
    <SearchWidget query={search} onChange={onSearchChange} />
    <FilterDropdown
      size="small"
      filter={filter}
      setFilter={onFilterChange}
      filtersConfig={getFiltersConfigs(['archived'])}
    />
    <Box align="center">
      <Button
        className={styles.button}
        color="primary"
        icon={PlusCircleIcon}
        label={t`Add job`}
        size="small"
        variant="filled"
        onClick={hasAnyTemplates ? onAddJobFromTemplate : onAddJobFromScratch}
      />
      <ActionsDropdown size="small" actions={actions} />
    </Box>
  </Pane.Header>
)
